// Lightweight per-request SSR phase/component timing.
//
// The App instance that owns run()/loadAsyncData() is a singleton reused
// across every SSR request (see app.js's run() reset comment for the full
// story) and ssrv2 handles requests concurrently via the event loop, so any
// profiling state stored on `this` would leak between in-flight requests.
// createProfiler() returns a fresh, self-contained object instead - callers
// thread it through as a plain value (function params / closures), never as
// instance state, so concurrent requests can't stomp on each other's timings.
function createProfiler(enabled) {
  if (!enabled) {
    return {
      enabled: false,
      start() {},
      end() {},
      summary() {
        return []
      }
    }
  }

  const entries = []
  const starts = {}

  return {
    enabled: true,
    start(label) {
      starts[label] = Date.now()
    },
    end(label, extra) {
      const startedAt = starts[label]
      if (startedAt === undefined) {
        return
      }
      entries.push({ label, ms: Date.now() - startedAt, ...extra })
      delete starts[label]
    },
    summary() {
      return entries
    }
  }
}

export default createProfiler
